// src/pages/NoAccess.jsx
import React from 'react';
import { useMsal } from '@azure/msal-react';

const NoAccess = () => {
    const { instance, accounts } = useMsal();
    const currentAccount = accounts[0];

    const handleChangeAccount = async () => {
        try {
            await instance.logoutPopup();
            await instance.loginPopup();
            window.location.href = "/chat";
        } catch (error) {
            console.error('Error al cambiar de cuenta:', error);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            padding: '2rem',
            background: "linear-gradient(0, #464d61, #798195)",
            fontFamily: 'Arial, sans-serif',
            textAlign: 'center',
            color: '#fff'
        }}>
            <div style={{
                backgroundColor: '#ffffff',
                color: '#2c3e50',
                padding: '3rem',
                borderRadius: '16px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                maxWidth: '500px',
                width: '100%'
            }}>
                <h1 style={{ fontSize: '2rem', color: '#c0392b' }}>🚫 Acceso Denegado</h1>

                {currentAccount && (
                    <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
                        Estás conectado como: <strong>{currentAccount.username}</strong>
                    </p>
                )}

                <p style={{ fontSize: '1.1rem', marginTop: '1rem' }}>
                    No tienes permisos para acceder a esta aplicación.
                </p>
                <p style={{ marginTop: '1rem', color: '#555' }}>
                    Si crees que esto es un error, solicita acceso a{' '}
                    <a
                        href="mailto:antonio.diazcarpio@telefonica.com"
                        style={{ color: '#2980b9', textDecoration: 'none', fontWeight: 'bold' }}
                    >
                        antonio.diazcarpio@telefonica.com
                    </a>
                </p>

                <button
                    onClick={handleChangeAccount}
                    style={{
                        marginTop: '2rem',
                        padding: '0.75rem 1.5rem',
                        fontSize: '1rem',
                        backgroundColor: '#2c3e50',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer'
                    }}
                >
                    Cambiar de cuenta
                </button>
            </div>
        </div>
    );
};

export default NoAccess;
